import { Helmet } from 'react-helmet';
import DongtienDetail
  from 'src/components/Dongtien-detail/DongtienDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

//import DongtienToolbar from '../components/Dongtien-detail/DongtienToolbar';

const Dongtien = () => (
  <>
    <Helmet>
      <title>Dòng tiền</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        {/* <DongtienToolbar /> */}
        <Box sx={{ pt: 3 }}>
          <DongtienDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Dongtien;
